var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.041 14.8755C19.0803 19.1128 22.7582 20.5229 22.799 20.5409C22.7679 20.6403 22.2113 22.5503 20.8613 24.5233C19.6943 26.229 18.483 27.9284 16.575 27.9636C14.7002 27.9982 14.0973 26.8518 11.9538 26.8518C9.81103 26.8518 9.14122 27.9284 7.36648 27.9982C5.52475 28.0678 4.12228 26.1537 2.94556 24.4542C0.541056 20.9779 -1.29648 14.6311 1.17087 10.3469C2.39659 8.21929 4.58705 6.87202 6.9646 6.83747C8.77314 6.80298 10.4802 8.0542 11.5858 8.0542C12.6906 8.0542 14.7651 6.54949 16.9458 6.77048C17.8588 6.80848 20.4214 7.13926 22.067 9.5479C21.9344 9.6301 19.0092 11.333 19.041 14.8755V14.8755ZM15.5175 4.47062C16.4953 3.28704 17.1534 1.6394 16.9738 0C15.5644 0.0566457 13.8601 0.939192 12.8492 2.12212C11.9432 3.16965 11.1497 4.8463 11.3638 6.45325C12.9348 6.57479 14.5396 5.65495 15.5175 4.47062",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.2e4e1a4d7cf935e55fcf6e9af3150c4d.svg";
export { ForwardRef as ReactComponent };